/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconShieldCheckeredFilled = createSolidComponent(
  "shield-checkered-filled",
  "IconShieldCheckeredFilled",
  [
    [
      "path",
      {
        d: "M11.013 12v9.754a13 13 0 0 1 -8.733 -9.754h8.734zm9.284 3.794a13 13 0 0 1 -7.283 5.951l-.001 -9.745h8.708a12.96 12.96 0 0 1 -1.424 3.794zm-9.283 -13.268l-.001 7.474h-8.986c-.068 -1.432 .101 -2.88 .514 -4.282a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.192 -2.256l.276 -.219zm1.999 7.474v-7.453l-.09 -.073a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717c.413 1.403 .582 2.85 .514 4.282h-8.96z",
        "stroke-width": "0",
        fill: "currentColor"
      }
    ]
  ]
);

export { IconShieldCheckeredFilled as default };
//# sourceMappingURL=IconShieldCheckeredFilled.js.map
